import { render, staticRenderFns } from "./TourneyLobby.vue?vue&type=template&id=1cd50220&"
import script from "./TourneyLobby.vue?vue&type=script&lang=ts&"
export * from "./TourneyLobby.vue?vue&type=script&lang=ts&"
import style0 from "./TourneyLobby.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports